// extracted by mini-css-extract-plugin
export default {"container":"styles_container__V0Ays","label":"styles_label__tbGo8","fileInput":"styles_fileInput__NgDkA","button":"styles_button__p64DY","image":"styles_image__0cpey"};